module.exports = __webpack_public_path__ + "img/boltyanskiy.3229c302.jpg";